import {
  useGetAutoDataFeatureOptions,
  useGetAutoDataFeatures,
  useGetAutoDataSpecifications
} from "@dealer-center/ddc-pages-vin-decode-fetch";

import { LoadingIndicator } from "@dealer-center/core-custom-components";
import styled from "styled-components";

const StyledTechSpecs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const StyledTechSpecsCollumn = styled.div`
  width: 50%;
  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  ul {
    padding-left: 1em;
    margin: 0;
    li {
      margin-bottom: 0.5rem;
    }
  }
`;
interface AutoDataOptionsProps {
  vehicleId: string;
}
export const AutoDataTechSpecs = ({ vehicleId }: AutoDataOptionsProps) => {
  const { data: specifications, isLoading: specificationsLoading } =
    useGetAutoDataSpecifications(vehicleId);
  const { data: featureOptions, isLoading: featureOptionsLoading } =
    useGetAutoDataFeatureOptions(vehicleId);
  const { data: features, isLoading: featuresLoading } =
    useGetAutoDataFeatures(vehicleId);
  return (
    <StyledTechSpecs>
      <StyledTechSpecsCollumn>
        <h3>Options</h3>
        {specificationsLoading && (
          <LoadingIndicator actionName="VIN Decode Options Loading" />
        )}
        <ul>
          {specifications?.map(option => {
            return (
              option.data &&
              option.data
                .sort((a, b) => a.contents.localeCompare(b.contents))
                .map(option2 => (
                  <li key={option2.contents}>{option2.contents}</li>
                ))
            );
          })}
        </ul>
      </StyledTechSpecsCollumn>
      <StyledTechSpecsCollumn>
        <h3>Feature Options</h3>
        {featureOptionsLoading && (
          <LoadingIndicator actionName="VIN Decode Feature Options Loading" />
        )}
        <ul>
          {featureOptions
            ?.sort((a, b) => a.localeCompare(b))
            .map(option => <li key={option}>{option}</li>)}
        </ul>
      </StyledTechSpecsCollumn>
      <StyledTechSpecsCollumn>
        <h3>Features</h3>
        {featuresLoading && (
          <LoadingIndicator actionName="VIN Decode Features Loading" />
        )}
        <ul>
          {features
            ?.sort((a, b) => a.title.localeCompare(b.title))
            .map(option => {
              return (
                <div key={option.title}>
                  <h4>{option.title}</h4>
                  <ul>
                    {option.data &&
                      option.data
                        .sort((a, b) => a.contents.localeCompare(b.contents))
                        .map(option2 => (
                          <li key={option2.contents}>{option2.contents}</li>
                        ))}
                  </ul>
                </div>
              );
            })}
        </ul>
      </StyledTechSpecsCollumn>
    </StyledTechSpecs>
  );
};
